module.exports = __webpack_public_path__ + "img/theme-title2.ded3c183.png";